<template>
    <div>
        <Toast position="center" group="ct" />
        <Toast position="top-left" group="tl" />
        <Toast position="top-center" group="tc" />
        <Toast position="top-right" group="tr" />
        <Toast position="bottom-left" group="bl" />
        <Toast position="bottom-center" group="bc" />
        <Toast position="bottom-right" group="br" />
    </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { Websocket } from '@hc/composables/socket';
import { registerListeners } from '@hc/composables/listeners/register';

const { echo } = Websocket();

onMounted(() => {
    registerListeners(echo);
});
</script>
